/**
 * Обновление UI элементов темы
 * # ⛓️ CURSOR_ANCHOR:ui:theme-ui
 */

(function() {
  'use strict';

  var THEME_LIGHT = window.THEME_CONSTANTS.LIGHT;
  var THEME_DARK = window.THEME_CONSTANTS.DARK;
  var THEME_AUTO = window.THEME_CONSTANTS.AUTO;

  /**
   * Показать анимацию смены иконки темы при клике.
   * Старая иконка плавно исчезает, новая появляется.
   * Overlay остается видимым, пока мышка на логотипе.
   */
  function showThemeIconAnimation(logoCell, nextTheme) {
    if (!logoCell) return;
    
    // Получаем все иконки
    var sunIcon = logoCell.querySelector('.theme-icon-sun');
    var moonIcon = logoCell.querySelector('.theme-icon-moon');
    var autoIcon = logoCell.querySelector('.theme-icon-auto');
    
    // Определяем, какую иконку показывать (это тема, которая ТОЛЬКО ЧТО применилась)
    // После toggle() будет вызван updateLogoNextTheme(), который обновит data-next-theme
    // Нам нужно показать иконку текущего nextTheme (той темы, на которую переключились)
    var iconToShow = null;
    if (nextTheme === THEME_LIGHT) {
      iconToShow = sunIcon;
    } else if (nextTheme === THEME_DARK) {
      iconToShow = moonIcon;
    } else if (nextTheme === THEME_AUTO) {
      iconToShow = autoIcon;
    }
    
    if (!iconToShow) return;
    
    // Добавляем класс анимации (CSS сохранит overlay видимым и логотип затемненным)
    logoCell.classList.add('theme-animating');
    
    // Анимация смены иконок:
    // 1. Скрываем ВСЕ иконки (включая ту, что была при hover)
    // 2. Показываем только нужную иконку
    
    var allIcons = [sunIcon, moonIcon, autoIcon];
    allIcons.forEach(function(icon) {
      if (!icon) return;
      
      if (icon === iconToShow) {
        // Показываем эту иконку с анимацией появления
        icon.style.setProperty('transition', 'opacity 0.25s ease-out, transform 0.25s ease-out', 'important');
        icon.style.setProperty('opacity', '1', 'important');
        icon.style.setProperty('transform', icon === autoIcon ? 'scale(1.05)' : 'scale(1.1)', 'important');
        icon.style.setProperty('visibility', 'visible', 'important');
      } else {
        // Скрываем эту иконку
        icon.style.setProperty('transition', 'opacity 0.15s ease-out, transform 0.15s ease-out', 'important');
        icon.style.setProperty('opacity', '0', 'important');
        icon.style.setProperty('transform', 'scale(0.7)', 'important');
        icon.style.setProperty('visibility', 'hidden', 'important');
      }
    });
    
    // После короткой паузы убираем inline стили - CSS hover возьмет управление
    // data-next-theme уже обновлен через updateLogoNextTheme()
    setTimeout(function() {
      logoCell.classList.remove('theme-animating');
      
      // Сбрасываем inline стили, чтобы CSS hover-правила работали
      allIcons.forEach(function(icon) {
        if (!icon) return;
        icon.style.removeProperty('opacity');
        icon.style.removeProperty('transform');
        icon.style.removeProperty('visibility');
        icon.style.removeProperty('transition');
      });
    }, 300);
  }

  /**
   * Обновить атрибут data-next-theme на логотипе
   */
  function updateLogoNextTheme() {
    var logoCell = document.getElementById('logo-cell');
    if (!logoCell) return;
    
    var current = window.THEME_STORAGE.get();
    var next = window.THEME_DETECTION.getNext(current);
    
    logoCell.setAttribute('data-next-theme', next);
    
    // Обновляем title для подсказки
    var titles = {
      'light': 'Переключить на светлую тему',
      'dark': 'Переключить на темную тему',
      'auto': 'Переключить на автоматическую тему'
    };
    logoCell.setAttribute('title', titles[next] || 'Переключить тему');
  }

  /**
   * Обновить атрибут data-next-theme на логотипе (для показа правильной иконки при hover)
   */
  function updateThemeToggleButton(theme) {
    updateLogoNextTheme();
  }

  /**
   * Инициализация переключателей в модальном окне
   */
  function initModalControls() {
    // 1. Режим темы (Light/Auto/Dark)
    var themeRadios = document.querySelectorAll('input[name="theme-mode"]');
    var currentTheme = window.THEME_STORAGE.get();
    
    themeRadios.forEach(function(radio) {
      if (radio.value === currentTheme) {
        radio.checked = true;
      }
      
      radio.addEventListener('change', function() {
        if (this.checked) {
          window.THEME_TOGGLE.set(this.value);
        }
      });
    });

    // 2. Цветовые профили
    var profileCards = document.querySelectorAll('.color-profile-card');
    var currentProfile = window.THEME_STORAGE.getProfile();
    
    function updateActiveProfileCard(profile) {
      profileCards.forEach(function(card) {
        if (card.getAttribute('data-profile') === profile) {
          card.classList.add('active');
        } else {
          card.classList.remove('active');
        }
      });
    }

    updateActiveProfileCard(currentProfile);

    profileCards.forEach(function(card) {
      card.addEventListener('click', function() {
        var profile = this.getAttribute('data-profile');
        window.THEME_STORAGE.setProfile(profile);
        window.THEME_APPLICATION.apply(window.THEME_STORAGE.get());
        updateActiveProfileCard(profile);
      });
    });
  }

  window.THEME_UI = {
    updateToggleButton: updateThemeToggleButton,
    updateLogoNextTheme: updateLogoNextTheme,
    showThemeIconAnimation: showThemeIconAnimation,
    initModalControls: initModalControls
  };
})();

